import { render, staticRenderFns } from "./PrivateHome.vue?vue&type=template&id=66bd0344&scoped=true"
import script from "./PrivateHome.vue?vue&type=script&lang=js"
export * from "./PrivateHome.vue?vue&type=script&lang=js"
import style0 from "./PrivateHome.vue?vue&type=style&index=0&id=66bd0344&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bd0344",
  null
  
)

export default component.exports